import { VgApiResult, vgApiRequest } from "./vg-api.service";

export type ServiceDetail = {
  serviceId: number;
  orgId: number;
  name: string;
  description: string;
  taxRate?: number;
  monetaryAmount?: number;
  monetaryCurrency?: number;
};

function pickService(data: Record<string, unknown> | null | undefined): Partial<ServiceDetail> {
  if (!data) return {};
  return {
    serviceId: Number(data.serviceId ?? data.ServiceId ?? 0),
    orgId: Number(data.orgId ?? data.OrgId ?? 0),
    name: String(data.name ?? data.Name ?? ""),
    description: String(data.description ?? data.Description ?? ""),
    taxRate: data.taxRate != null ? Number(data.taxRate) : undefined,
    monetaryAmount: data.monetaryAmount != null ? Number(data.monetaryAmount) : undefined,
    monetaryCurrency:
      data.monetaryCurrency != null ? Number(data.monetaryCurrency) : undefined,
  };
}

export async function createOrgService(
  accessToken: string,
  payload: { orgId: number; name: string; description: string; taxRate?: number; monetaryCurrency?: number }
): Promise<VgApiResult<{ newRecordID?: number; NewRecordID?: number }>> {
  return vgApiRequest(accessToken, "Create_Service", {
    orgId: payload.orgId,
    name: payload.name,
    description: payload.description,
    taxRate: payload.taxRate ?? 0,
    monetaryAmount: 0,
    monetaryCurrency: payload.monetaryCurrency ?? 978,
    isPlatformSpecific: 3,
  });
}

export async function readService(
  accessToken: string,
  orgId: number,
  serviceId: number
): Promise<VgApiResult<ServiceDetail>> {
  const { data, error } = await vgApiRequest<Record<string, unknown>>(accessToken, "Read_Service", {
    orgId,
    serviceId,
  });
  if (error) return { data: null, error };
  const p = pickService(data);
  return {
    data: {
      serviceId: p.serviceId ?? serviceId,
      orgId: p.orgId ?? orgId,
      name: p.name ?? "",
      description: p.description ?? "",
      taxRate: p.taxRate,
      monetaryAmount: p.monetaryAmount,
      monetaryCurrency: p.monetaryCurrency,
    },
    error: null,
  };
}

export async function updateOrgService(
  accessToken: string,
  payload: {
    orgId: number;
    serviceId: number;
    name: string;
    description: string;
    taxRate?: number;
    monetaryAmount?: number;
    monetaryCurrency?: number;
  }
): Promise<VgApiResult<unknown>> {
  return vgApiRequest(accessToken, "Update_Service", {
    orgId: payload.orgId,
    serviceId: payload.serviceId,
    name: payload.name,
    description: payload.description,
    taxRate: payload.taxRate ?? 0,
    monetaryAmount: payload.monetaryAmount ?? 0,
    monetaryCurrency: payload.monetaryCurrency ?? 978,
    isPlatformSpecific: 3,
  });
}

export async function deleteOrgService(
  accessToken: string,
  orgId: number,
  serviceId: number
): Promise<VgApiResult<unknown>> {
  return vgApiRequest(accessToken, "Delete_Service", { orgId, serviceId });
}
